import { useTheme } from '@mui/material'
import React from 'react'
import { ReactComponent as CustomEquipmentType } from 'src/assets/svg/equipments/custom_blue.svg'
import { ReactComponent as CustomEquipmentTypeWhite } from 'src/assets/svg/equipments/custom_white.svg'
import { ReactComponent as LiceSkirt } from 'src/assets/svg/equipments/liceskirt_blue.svg'
import { ReactComponent as LiceSkirtWhite } from 'src/assets/svg/equipments/liceskirt_white.svg'
import { ReactComponent as Net } from 'src/assets/svg/equipments/net_blue.svg'
import { ReactComponent as NetWhite } from 'src/assets/svg/equipments/net_white.svg'
import { ReactComponent as Ring } from 'src/assets/svg/equipments/ring.svg'
import { IMainComponentType } from 'src/enums'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

interface EquipmentIconProps {
  type: IMainComponentType
  isWhite?: boolean
  height?: string | number
  width?: string | number
}

export const EquipmentIcon: React.FC<EquipmentIconProps> = ({ type, isWhite, height = 28, width = 28 }) => {
  const theme = useTheme()
  switch (type) {
    case IMainComponentType.Ring:
      return isWhite ? (
        <Ring height={height} width={width} color={getThemeColor(theme, MUIThemeColors.white)} />
      ) : (
        <Ring height={height} width={width} color={getThemeColor(theme, MUIThemeColors.primaryMain)} />
      )
    case IMainComponentType.Net:
      return isWhite ? <NetWhite height={height} width={width} /> : <Net height={height} width={width} />
    case IMainComponentType.LiceSkirt:
      return isWhite ? <LiceSkirtWhite height={height} width={width} /> : <LiceSkirt height={height} width={width} />
    default:
      return isWhite ? (
        <CustomEquipmentTypeWhite height={height} width={width} />
      ) : (
        <CustomEquipmentType height={height} width={width} />
      )
  }
}
